import { useQuery } from '@apollo/client';
import { TrackEventInput } from '@updater/ui-tracker';
import { useEffect } from 'react';
import { useTracking } from 'react-tracking';
import { dollyMove, dollyMoveVariables } from 'types/generated/dollyMove';
import { cleanAddress } from 'utils/addresses';
import { GetDollyEligibility } from 'utils/queries';
import { useGetUserInfoQuery } from './use-get-user-info-query';

export const useDollyEligibility = () => {
  const { trackEvent } = useTracking<TrackEventInput<unknown>>({
    domain: 'mys',
    object: 'dolly_eligibility',
    verb: 'tracked',
  });

  const {
    data: userData,
    error: userError,
    loading: userLoading,
  } = useGetUserInfoQuery();
  const result = useQuery<dollyMove, dollyMoveVariables>(GetDollyEligibility, {
    variables: {
      input: {
        // @ts-expect-error FIXME: TS2322 - strict mode migration
        moveId: userData?.getUser.user.currentMove.id,
        // @ts-expect-error FIXME: TS2322 - strict mode migration
        fromAddress: cleanAddress(
          // @ts-expect-error FIXME: TS18047 - strict mode migration
          userData?.getUser.user.currentMove.fromAddress
        ),
        // @ts-expect-error FIXME: TS2322 - strict mode migration
        toAddress: cleanAddress(userData?.getUser.user.currentMove.toAddress),
        // @ts-expect-error FIXME: TS18047 - strict mode migration
        moveDate: userData?.getUser.user.currentMove.date,
      },
    },
    skip: userLoading || !userData || !!userError,
  });

  useEffect(() => {
    if (result.data) {
      trackEvent({
        details: {
          eligible: result.data.dollyMove?.eligible,
        },
      });
    }
  }, [trackEvent, result]);

  return result;
};
